import React, { Component } from "react";

class AgGridLoadingOverlay extends Component {
    render() {
        return (
            <div className="ag-grid-loader" role="status" aria-live="polite" aria-label="Loading">
                <div className="ag-grid-loader__panel">
                    <div className="ag-grid-loader__spinner">
                        <span />
                        <span />
                        <span />
                    </div>
                    <p className="ag-grid-loader__text">Loading data...</p>
                </div>
            </div>
        );
    }
}

export default AgGridLoadingOverlay;
